























































import { Component, Vue } from 'vue-property-decorator'
import * as Reveal from '@/assets/scripts/RevealOnScrollModule'

@Component
export default class VideoAutoPlay extends Vue {

	data() {
		return {
			PageTitle: "Video autoplay"
		}
	}
	mounted() {
		new Reveal.revealOnScrollModule();
	}
}
